import React from "react";
import Button from "../Button";

const defaultGetPages = (current, total) => {
  const left = [1, 2, 3];
  const right = [total - 2, total - 1, total];

  const pages = new Set();

  left.forEach((p) => p >= 1 && p <= total && pages.add(p));
  for (let p = current - 1; p <= current + 1; p++) {
    if (p >= 1 && p <= total) pages.add(p);
  }
  right.forEach((p) => p >= 1 && p <= total && pages.add(p));

  const sorted = [...pages].sort((a, b) => a - b);
  const final = [];

  for (let i = 0; i < sorted.length; i++) {
    final.push(sorted[i]);
    if (sorted[i + 1] && sorted[i + 1] !== sorted[i] + 1) {
      final.push("...");
    }
  }
  return final;
};

const PaginationComponent = ({
  current,
  total,
  onChange,
  getPages = defaultGetPages,
  prevButton = (
    <Button
      size="sm"
      hierarchy={{ type: "secondaryGrey", buttonText: "Previous" }}
      destructive={false}
      icon={{
        type: "leading",
        icon: (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {" "}
            <path
              d="M12.5016 6.66836H0.834961M0.834961 6.66836L6.66829 12.5017M0.834961 6.66836L6.66829 0.835022"
              stroke="#344054"
              stroke-width="1.67"
              stroke-linecap="round"
              stroke-linejoin="round"
            />{" "}
          </svg>
        ),
      }}
    />
  ),
  nextButton = (
    <Button
      size="sm"
      hierarchy={{ type: "secondaryGrey", buttonText: "Next" }}
      destructive={false}
      className="next"
      icon={{
        type: "trailing",
        icon: (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {" "}
            <path
              d="M0.834961 6.66836H12.5016M12.5016 6.66836L6.66829 0.835022M12.5016 6.66836L6.66829 12.5017"
              stroke="#344054"
              stroke-width="1.67"
              stroke-linecap="round"
              stroke-linejoin="round"
            />{" "}
          </svg>
        ),
      }}
    />
  ),
  pageIcon,
  className,
}) => {
  const pages = getPages(current, total);

  return (
    <div
      style={{ width: "100%", height: "68px", display: "flex", gap: 8 }}
      className={`custom-pagination-container ${className} ${total<=1 ?"onepage":""}`}
    >
      {prevButton && total>=2 &&
        React.cloneElement(prevButton, {
          onClick: () => current > 1 && onChange(current - 1),
        })}

      <div className={`custom-pagination-pages-container ${className}`}>
        {pages.map((p, idx) =>
          p === "..." ? (
            <svg
              width="10"
              height="2"
              viewBox="0 0 10 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.994318 1.98368C0.722538 1.98368 0.488873 1.88756 0.293324 1.69533C0.0977746 1.49978 0 1.26446 0 0.989363C0 0.717583 0.0977746 0.485575 0.293324 0.29334C0.488873 0.0977912 0.722538 1.65701e-05 0.994318 1.65701e-05C1.2661 1.65701e-05 1.49976 0.0977912 1.69531 0.29334C1.89086 0.485575 1.98864 0.717583 1.98864 0.989363C1.98864 1.17165 1.94224 1.33903 1.84943 1.49149C1.75994 1.64064 1.64062 1.75996 1.49148 1.84945C1.34233 1.93894 1.17661 1.98368 0.994318 1.98368ZM4.95916 1.98368C4.68738 1.98368 4.45372 1.88756 4.25817 1.69533C4.06262 1.49978 3.96484 1.26446 3.96484 0.989363C3.96484 0.717583 4.06262 0.485575 4.25817 0.29334C4.45372 0.0977912 4.68738 1.65701e-05 4.95916 1.65701e-05C5.23094 1.65701e-05 5.46461 0.0977912 5.66016 0.29334C5.85571 0.485575 5.95348 0.717583 5.95348 0.989363C5.95348 1.17165 5.90708 1.33903 5.81428 1.49149C5.72479 1.64064 5.60547 1.75996 5.45632 1.84945C5.30717 1.93894 5.14145 1.98368 4.95916 1.98368ZM8.92401 1.98368C8.65223 1.98368 8.41856 1.88756 8.22301 1.69533C8.02746 1.49978 7.92969 1.26446 7.92969 0.989363C7.92969 0.717583 8.02746 0.485575 8.22301 0.29334C8.41856 0.0977912 8.65223 1.65701e-05 8.92401 1.65701e-05C9.19579 1.65701e-05 9.42945 0.0977912 9.625 0.29334C9.82055 0.485575 9.91832 0.717583 9.91832 0.989363C9.91832 1.17165 9.87192 1.33903 9.77912 1.49149C9.68963 1.64064 9.57031 1.75996 9.42116 1.84945C9.27202 1.93894 9.1063 1.98368 8.92401 1.98368Z"
                fill="#667085"
              />
            </svg>
          ) : (
            <>
              {pageIcon &&
                React.cloneElement(pageIcon, {
                  onClick: () => {onChange(p)},
                })}
              <div
                className={`custom-pagination-pages ${className} ${current===p ? "selected":""}`}
                onClick={() => onChange(p)}
                style={{cursor:"pointer"}}
              >
                {p}
              </div>
            </>
          )
        )}
      </div>
      {nextButton && total>=2 &&
        React.cloneElement(nextButton, {
          onClick: () => current < total && onChange(current + 1),
        })}
    </div>
  );
};

export default PaginationComponent;
